var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teams---single-user",
    transform: "translate(-290.000000, -670.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-visa",
    transform: "translate(290.000000, 670.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,17.3333333 C28,18.806 26.806,20 25.3333333,20 L2.66666667,20 C1.194,20 0,18.806 0,17.3333333 L0,2.66666667 C0,1.194 1.194,0 2.66666667,0 L25.3333333,0 C26.806,0 28,1.194 28,2.66666667 L28,17.3333333 Z",
    id: "Path",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.333333, 6.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79066667,0.666666667 L3.04,5.888 C3.04,5.888 2.59533333,3.67933333 2.55133333,3.402 C1.55466667,1.128 0.084,1.25466667 0.084,1.25466667 L1.81733333,8 L1.81733333,7.99866667 L3.92466667,7.99866667 L6.83866667,0.666666667 L4.79066667,0.666666667 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6.45933333 8 8.37333333 8 9.53066667 0.666666667 7.59266667 0.666666667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0053333,0.666666667 L17.9913333,0.666666667 L14.8513333,8 L16.7526667,8 L17.1446667,6.95266667 L19.542,6.95266667 L19.746,8 L21.488,8 L20.0053333,0.666666667 Z M17.6753333,5.552 L18.7173333,2.78066667 L19.2626667,5.552 L17.6753333,5.552 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.246,2.804 C12.246,2.4 12.578,2.09933333 13.53,2.09933333 C14.1486667,2.09933333 14.8573333,2.54866667 14.8573333,2.54866667 L15.168,1.00933333 C15.168,1.00933333 14.2626667,0.666 13.374,0.666 C11.3613333,0.666 10.3233333,1.62866667 10.3233333,2.84733333 C10.3233333,5.05133333 12.976,4.74933333 12.976,5.88133333 C12.976,6.07533333 12.822,6.524 11.7173333,6.524 C10.6093333,6.524 9.878,6.118 9.878,6.118 L9.548,7.59533333 C9.548,7.59533333 10.2566667,7.99933333 11.626,7.99933333 C12.9986667,7.99933333 14.9026667,6.97266667 14.9026667,5.498 C14.9026667,3.724 12.246,3.596 12.246,2.804 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.14133333,10.63 L5.49733333,7.46466667 C5.49733333,7.46466667 5.206,6.77866667 4.44866667,6.77866667 C3.69133333,6.77866667 1.48866667,6.77866667 1.48866667,6.77866667 C1.48866667,6.77866667 5.26266667,7.89333333 6.14133333,10.63 Z",
    id: "Path",
    fill: "#FFC107"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisa);
export default __webpack_public_path__ + "static/media/icon-visa.97422ec46299d11bcf1e99bf3b14a03b.svg";
export { ForwardRef as ReactComponent };